export default __webpack_public_path__ + "static/media/supply-gray-icon-small.f2ed8bb0.svg";